import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FlipCardsSection from './components/FlipCardsSection';
import ProductsSection from './components/ProductsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';
import CustomCursor from './components/CustomCursor';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <main className="w-full overflow-x-hidden">
      <CustomCursor />
      <Navbar alwaysTransparent />
      <HeroSection />
      <AboutSection />
      <FlipCardsSection />
      <ProductsSection />
      <TestimonialsSection />
      <CtaSection />
      <Footer />
    </main>
  );
}
